module.exports = __webpack_public_path__ + "img/approval-2.e6bf5914.png";